import moment from 'moment';

export function formatDateString(dateString: string | undefined): string {
    if(dateString == undefined)
        return "";
    else
    {
        return moment.utc(dateString).local().format('DD-MM-YYYY HH:mm:ss');
    }
}